import { ChevronLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

import type { EditorChromeProps } from './editor-chrome';
import { EditorSaveButton } from './EditorSaveButton';
import { EditorSaveState } from './EditorSaveState';

import './editor-page.css';

export function EditorHeader(p: EditorChromeProps) {
  return (
    <header className="nb-ed-header">
      <div className="nb-ed-titles">
        <nav aria-label="Breadcrumb" className="nb-eyebrow nb-ed-crumb">
          {p.section} ›{' '}
          <Link to={p.listPath} style={{ color: 'inherit' }}>
            {p.listLabel}
          </Link>{' '}
          › {p.crumb}
        </nav>
        <h1 className="nb-display nb-ed-title">{p.title}</h1>
      </div>
      <EditorSaveState saved={p.saved} unsaved={p.dirty && !p.isNew} className="nb-ed-state" />
      <Link to={p.listPath} className={`nb-btn nb-ed-back${p.isNew ? ' nb-ed-back-cancel' : ''}`}>
        <ChevronLeft size={20} aria-hidden className="nb-ed-back-icon" />
        <span className="nb-ed-back-label">{p.isNew ? 'Cancel' : `Back to ${p.noun}s`}</span>
      </Link>
      <EditorSaveButton
        noun={p.noun}
        isNew={p.isNew}
        dirty={p.dirty}
        saving={p.saving}
        saved={p.saved}
        onSave={p.onSave}
      />
    </header>
  );
}
